// １日ごとのトレーニングの結果の集計
export function calculateDailyResults(transactions) {
  return transactions.reduce((acc, transaction) => {
    const day = transaction.date;
    if (!acc[day]) {
      acc[day] = { upperBody: 0, lowerBody: 0, cardio: 0 };
    }
    if (transaction.category === "upperBody") {
      acc[day].upperBody += transaction.total_score;
    }
    if (transaction.category === "lowerBody") {
      acc[day].lowerBody += transaction.total_score;
    }
    if (transaction.category === "cardio") {
      acc[day].cardio += transaction.total_score;
    }
    return acc;
  }, {});
  // acc:
  // {
  //     "2026-05-20":{upperBody:300,lowerBody: 400,cardio:200 },
  //     "2026-05-21":{upperBody:300,lowerBody: 400,cardio:200 }
  // }
}

// カテゴリ毎のトレーニングの結果の集計
export function calculateResults(transactions) {
  return transactions.reduce(
    (acc, transaction) => {
      if (transaction.category === "upperBody") {
        acc.upperBody += transaction.total_score;
      }
      if (transaction.category === "lowerBody") {
        acc.lowerBody += transaction.total_score;
      }
      if (transaction.category === "cardio") {
        acc.cardio += transaction.total_score;
      }
      return acc;
    },
    {
      upperBody: 0,
      lowerBody: 0,
      cardio: 0,
    },
  );
}
